export default "__VITE_ASSET__BQiVuNww__"